package com.ijoin.data.api

import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.setBody
import io.ktor.client.request.parameter
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.client.plugins.*
import com.ijoin.data.model.PageResponse
import com.ijoin.data.api.ApiClient.addAuthToken
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive

class ContactApi {
    suspend fun submitContact(
        eventId: String,
        phone: String? = null,
        comment: String? = null,
        formData: Map<String, Any>? = null
    ): Result<ContactRequestDto> = runCatching {
        val jsonFormData = formData?.let { map ->
            JsonObject(map.mapValues { (_, value) ->
                when (value) {
                    is String -> JsonPrimitive(value)
                    is Number -> JsonPrimitive(value)
                    is Boolean -> JsonPrimitive(value)
                    else -> JsonPrimitive(value.toString())
                }
            })
        }
        val payload = ContactRequest(phone = phone, comment = comment, formData = jsonFormData)
        ApiClient.executeWithTokenRefresh {
            ApiClient.client.post("${ApiClient.getBaseUrl()}/api/events/$eventId/contact-requests") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(payload)
            }.body<ContactRequestDto>()
        }
    }

    suspend fun updateBookingId(eventId: String, contactRequestId: Long, bookingId: Long): Result<ContactRequestDto> = runCatching {
        ApiClient.executeWithTokenRefresh {
            ApiClient.client.patch("${ApiClient.getBaseUrl()}/api/events/$eventId/contact-requests/$contactRequestId/booking") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(UpdateBookingIdRequest(bookingId = bookingId))
            }.body<ContactRequestDto>()
        }
    }

    @Serializable
    data class UpdateBookingIdRequest(val bookingId: Long)

    @Serializable
    data class ContactRequest(
        val phone: String? = null,
        val comment: String? = null,
        val formData: JsonObject? = null
    )

    @Serializable
    data class ContactRequestDto(
        val id: Long,
        val eventId: String,
        val userId: Long? = null,
        val phone: String? = null,
        val comment: String? = null,
        val bookingId: Long? = null,
        val formData: JsonObject? = null,
        val createdAt: String? = null,
    )

    suspend fun listPaged(eventId: String, page: Int, size: Int): Result<PageResponse<ContactRequestDto?>> = runCatching {
        ApiClient.executeWithTokenRefresh {
            ApiClient.client.get("${ApiClient.getBaseUrl()}/api/events/$eventId/contact-requests") {
                addAuthToken()
                parameter("page", page)
                parameter("size", size)
            }.body<PageResponse<ContactRequestDto?>>()
        }
    }
}
